import { AnyAction } from 'redux'
import { createSelector } from 'reselect'
import { SIMILAR_TEMPLATES_ERROR, SIMILAR_TEMPLATES_DONE, SIMILAR_TEMPLATES_START, SIMILAR_TEMPLATES_RESET } from '../constants'
import { StringDictionary } from 'shared/types/util'
import type { State } from 'shared/types/gallery/state'

interface SimilarTemplatesState {
  tileEntities: {
    byId: StringDictionary<State.TileEntity>
    allIds: string[]
  }
  designs: {
    byId: StringDictionary<State.Design>
    allIds: string[]
  }
  loading: boolean
  error: Error | null
}

const initialState: SimilarTemplatesState = {
  tileEntities: {
    byId: {},
    allIds: [],
  },
  designs: {
    byId: {},
    allIds: [],
  },
  loading: false,
  error: null,
}

export function reducer(state: SimilarTemplatesState = initialState, action: AnyAction): SimilarTemplatesState {
  switch (action.type) {
    case SIMILAR_TEMPLATES_START:
      return {
        ...state,
        loading: action.payload,
        error: null,
      }
    case SIMILAR_TEMPLATES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case SIMILAR_TEMPLATES_DONE: {
      const { designs, tileEntities } = action.payload

      return {
        ...state,
        designs: { ...designs },
        tileEntities: { ...tileEntities },
        loading: false,
        error: null,
      }
    }
    case SIMILAR_TEMPLATES_RESET:
      return initialState
    default:
      return state
  }
}

export const similarTemplatesIdsSelector = (state: State.GlobalState): string[] => state.similarTemplates.tileEntities.allIds

export const similarTemplatesByIdSelector = createSelector(
  (state: State.GlobalState) => state.similarTemplates.tileEntities.byId,
  (byId) =>
    (id: string): State.TileEntity =>
      byId[id],
)
export const similarDesignsSelector = (state: State.GlobalState): State.DesignState => state.similarTemplates.designs

export const similarDesignByIdSelector = createSelector(
  (state: State.GlobalState) => state.similarTemplates.designs.byId,
  (byId) =>
    (id: string): State.Design =>
      byId[id],
)

export const similarTemplatesLoadingSelector = (state: State.GlobalState): boolean => state.similarTemplates.loading
export const similarTemplatesErrorSelector = (state: State.GlobalState): Error | null => state.similarTemplates.error
